import React, { useState } from 'react';
import styled from 'styled-components';

const ImageContainer = styled.div`
  width: ${props => props.$size || '40px'};
  height: ${props => props.$size || '40px'};
  border-radius: ${props => props.theme.radii.sm};
  background: ${props => props.theme.colors.bgElevated};
  border: 1px solid ${props => props.theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  
  &:hover {
    opacity: 0.8;
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.2s;
`;

const PlaceholderIcon = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
  color: #9ca3af;
  font-size: ${props => props.$size === 'large' ? '2rem' : '1rem'};
  font-weight: 500;
`;

const ProductImageComponent = ({ 
  src, 
  alt, 
  size = '40px', 
  fallbackIcon = '📦',
  ...props 
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <ImageContainer $size={size} {...props}>
      {!imageError && src ? (
        <ProductImage
          src={src}
          alt={alt}
          onError={handleImageError}
          onLoad={handleImageLoad}
          style={{ opacity: imageLoaded ? 1 : 0 }}
        />
      ) : (
        <PlaceholderIcon $size={size === 'large' ? 'large' : 'small'}>
          {fallbackIcon}
        </PlaceholderIcon>
      )}
    </ImageContainer>
  );
};

export default ProductImageComponent;
